<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <input 
      v-show="C_isVisible"
      v-model="DV_inputText" 
      :style="C_inputStyle" 
      :disabled="P_disabled == 'true' || P_editing"
      :placeholder="P_placeholder" 
    >
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    "P_placeholder",
    "P_value",
    'P_fontColor',
    'P_background',
    'P_fontSize',
    'P_borderColor',
    'P_padding',
    'P_customCss'
  ],
  mixins: [bi10GridComponent],
  data () {
    return {
      // we can get this from prop
      DV_inputText: this.P_value || ""
    }
  },
  computed: {
    C_inputStyle () {
      let customStyle = {
        height: '100%',
        width: '100%',
        marginTop: '5px',
        marginLeft: '5px'
      }

      if (this.P_fontSize) customStyle["fontSize"] = this.P_fontSize
      if (this.P_background) customStyle["backgroundColor"] = this.P_background
      if (this.P_borderColor) customStyle["borderColor"] = this.P_borderColor
      if (this.P_fontColor) customStyle["color"] = this.P_fontColor
      if (this.P_padding) customStyle["padding"] = this.P_padding

      return customStyle;
    }
  },
  watch: {
    P_value() {
      this.DV_inputText = this.P_value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Grid/GInput.vue